import React from 'react'
import { convertShortcodesToHTML } from '../../../services/common'
import { Parser } from '../../common'

const Information = ({ block }) => {
    return (
        <div className="baseocom-information-container">
            {block?.content && <p>{convertShortcodesToHTML(block?.content)}</p>}
            {block?.childrens && <Parser content_block={block?.childrens} />}
        </div>
    )
}

export default Information
